import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ExportModel } from '../../../../../../../common/dist/angular/models/export.model';
import { TransformerClassType } from '../../core/interceptors/transformer.http-interceptor';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ExportApiController {
  constructor(private readonly httpClient: HttpClient, @Inject('environment.api.url') private readonly apiUrl: string) {
  }

  public async get(id: string): Promise<ExportModel> {
    return this.httpClient.get<ExportModel>(`${this.apiUrl}/api/exports/${id}`, {
      context: new HttpContext().set(TransformerClassType, ExportModel),
    }).toPromise();
  }

  public async download(id: string): Promise<any> {
    return this.httpClient.get(`${this.apiUrl}/api/exports/${id}/download`, {
      responseType: 'arraybuffer',
    }).pipe(
      switchMap(async (response) => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //const file = new File([blob], `${id}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        window.open(window.URL.createObjectURL(blob));
      }),
    ).toPromise();
  }
}
